"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModificationOptionType = exports.PartnerModificationIndex = exports.ModificationType = void 0;
var ModificationType;
(function (ModificationType) {
    ModificationType["PARTNER"] = "partner";
    ModificationType["DEPARTMENT"] = "department";
    ModificationType["VOUCHER"] = "voucher";
})(ModificationType = exports.ModificationType || (exports.ModificationType = {}));
/** 取引先補正のパラメータのIndex */
var PartnerModificationIndex;
(function (PartnerModificationIndex) {
    PartnerModificationIndex[PartnerModificationIndex["NAME"] = 0] = "NAME";
    PartnerModificationIndex[PartnerModificationIndex["TEL"] = 1] = "TEL";
    PartnerModificationIndex[PartnerModificationIndex["ADDRESS"] = 2] = "ADDRESS";
    PartnerModificationIndex[PartnerModificationIndex["BANK_NAME"] = 3] = "BANK_NAME";
    PartnerModificationIndex[PartnerModificationIndex["BANK_ACCOUNT_NUMBER"] = 4] = "BANK_ACCOUNT_NUMBER";
    PartnerModificationIndex[PartnerModificationIndex["BANK_ACCOUNT_TYPE"] = 5] = "BANK_ACCOUNT_TYPE";
    PartnerModificationIndex[PartnerModificationIndex["BANK_ACCOUNT_NAME"] = 6] = "BANK_ACCOUNT_NAME";
    PartnerModificationIndex[PartnerModificationIndex["CODE"] = 7] = "CODE";
    PartnerModificationIndex[PartnerModificationIndex["BILLED_FROM"] = 8] = "BILLED_FROM";
    PartnerModificationIndex[PartnerModificationIndex["REGISTRATION_NUMBER"] = 9] = "REGISTRATION_NUMBER";
})(PartnerModificationIndex = exports.PartnerModificationIndex || (exports.PartnerModificationIndex = {}));
var ModificationOptionType;
(function (ModificationOptionType) {
    ModificationOptionType["PARTNER_BANK_PRECEDENCE"] = "partnerBankPrecedence";
    ModificationOptionType["PRESET_AUTOCOMPLETE"] = "presetAutocompleteEnabled";
})(ModificationOptionType = exports.ModificationOptionType || (exports.ModificationOptionType = {}));
